export default {
  courseList: [],
  course: {},
  courseSubjectList: [],
  courseSubjectDetail: {},

  subjectListNotInCourse: [],
  courseDetail: {},
  subjectDetail: {},
  chapterDetail: {},
  chapterList: [],
  examList: [],
  sheetList: [],
  chaperSheetList: [],
  examDetail: {},
  lecture_videoList: [],
  lecture_videoDetails: {},
  quiz_title: '',
  question: {},
  quizDetail: {},
  quizDetailForPage: {},
  questionList: [],
  uploadPercentage: 0
}
